import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Lottie from "lottie-react";
import successAnimation from "../assets/animations/success.json";

const ContectPage = ({ toggleDarkMode, isDarkMode }) => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault(); // 防止默认提交
    setSubmitted(true);

    // 5 秒后隐藏动画
    setTimeout(() => setSubmitted(false), 5000);
  };

  return (
    <>
      <Header toggleDarkMode={toggleDarkMode} isDarkMode={isDarkMode} />
      <section className="min-h-[100vh] flex items-center">
        <div className="container mx-auto px-4">
          <div className="mx-auto max-w-2xl">
            <h2 className="font-earth text-5xl md:text-8xl font-bold text-center mb-12">
              Contact
            </h2>
            <form className="space-y-6" onSubmit={handleSubmit}>
              {/* name */}
              <div>
                <label className="block mb-2 text-[30px] font-semibold text-gray-700 dark:text-gray-200">
                  Name
                </label>
                <input
                  type="text"
                  placeholder="Your name"
                  className="w-full px-4 py-2 rounded-lg bg-white/10 border border-gray-500 dark:border-gray-600 text-black dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 dark:focus:ring-green-400 focus:ring-red-700 text-[20px]"
                />
              </div>

              {/* email */}
              <div>
                <label className="block mb-2 text-[30px] font-semibold text-gray-700 dark:text-gray-200">
                  Email
                </label>
                <input
                  type="email"
                  placeholder="your@email.com"
                  className="w-full px-4 py-2 rounded-lg bg-white/10 border border-gray-500 dark:border-gray-600 text-black dark:text-white placeholder-gray-600 dark:placeholder-gray-500 focus:outline-none focus:ring-2 dark:focus:ring-green-400 focus:ring-red-700 text-[20px]"
                />
              </div>

              {/* message */}
              <div>
                <label className="block mb-2 text-[30px] font-semibold text-gray-700 dark:text-gray-200">
                  Message
                </label>
                <textarea
                  rows="6"
                  placeholder="Your message..."
                  className="w-full px-4 py-2 rounded-lg bg-white/10 border border-gray-500 dark:border-gray-600 text-black dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 dark:focus:ring-green-400 focus:ring-red-700 text-[20px]"
                />
              </div>

              {/* button */}
              <div className="text-center">
                <button
                  type="submit"
                  className="mt-4 px-8 py-3 rounded-lg bg-red-600 dark:bg-green-500 hover:bg-red-700 dark:hover:bg-green-600 text-white text-lg font-semibold transition"
                >
                  Send Message
                </button>
              </div>
            </form>

            {/* Lottie Success Animation */}
            {submitted && (
              <div className="w-64 h-64 mx-auto mt-8">
                <Lottie animationData={successAnimation} loop={false} />
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default ContectPage;
